import { Component, Input } from '@angular/core';


@Component({
    selector: 'ui-progress',
    styles: [
        `
        @keyframes progress-bar-stripes {
            from {
                background-position: 1rem 0;
            }
            to {
                background-position: 0 0;
            }
        }
        @keyframes progress-grow {
            from {
                width: 0;
            }
        }
        :host {
            display: block;
            background: #E9ECEF;
            border-radius: 0.25rem;
            overflow: hidden;
        }
        .progress-bar {
            color: #fff;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            min-height: 1rem;
            background-color: #1583D6;
            background-image: linear-gradient(
                45deg,
                rgba(255, 255, 255, 0.15) 25%,
                transparent 25%,
                transparent 50%,
                rgba(255, 255, 255, 0.15) 50%,
                rgba(255, 255, 255, 0.15) 75%,
                transparent 75%,
                transparent
            );
            background-size: 1rem 1rem;
            width: 100%;
            animation: progress-bar-stripes 1s linear infinite;
        }
        .progress-bar.timed {
            width: 99%;
            animation: progress-bar-stripes 1s linear infinite, progress-grow var(--progress-duration) ease-out;
        }
        `
    ],
    template: `
        <div
            role="progressbar"
            class="progress-bar"
            [class.timed]="!!seconds"
            [style.--progress-duration]="seconds + 's'"
            aria-valuetext="Loading...">
            <ng-content></ng-content>
        </div>
    `,
})
export class ProgressComponent {

    @Input() seconds = 0;
}
